
import { defineComponent } from "vue";

export default defineComponent({
    name: "LinkageChangePasswordRescueProfileConfirm",
    setup() {
        return {
        };
    }
});
